<h3 class="bo-label-text" [innerHTML]="referenceDataLabels.AffordabilityResultsResults | localizeLabel"></h3>

<div class="dots-separator"></div>

<div class="details__field" *ngIf="!affordabilityResults.IsSuitabilityReport">
  <div class="details-label" [innerHTML]="referenceDataLabels.AffordabilityResult | localizeLabel"></div>

  <div class="bo-label-text"
    [ngClass]="{'orange': affordabilityResults.AffordabilityResultCode !== referenceDataConstants.TransactCheckStatusCodePass,
                    'green': affordabilityResults.AffordabilityResultCode === referenceDataConstants.TransactCheckStatusCodePass}">
    <span *ngIf="affordabilityResults.AffordabilityResultCode === referenceDataConstants.TransactCheckStatusCodePass"
      [innerHTML]="referenceDataLabels.Pass | localizeLabel | uppercase"></span>
    <span *ngIf="affordabilityResults.AffordabilityResultCode !== referenceDataConstants.TransactCheckStatusCodePass"
      [innerHTML]="referenceDataLabels.Fail | localizeLabel | uppercase"></span>
  </div>
</div>

<div class="details__field">
  <div class="details-label"
    [innerHTML]="referenceDataLabels.AffordabilityResultsMonthlyMortgagePaymentRepayment | localizeLabel"></div>
  <div class="details-info"> {{ affordabilityResults.MonthlyMortgagagePaymentRepayment }}</div>
</div>

<div class="details__field">
  <div class="details-label"
    [innerHTML]="referenceDataLabels.AffordabilityResultsMonthlyMortgagePaymentInterest | localizeLabel"></div>
  <div class="details-info"> {{ affordabilityResults.MonthlyMortgagagePaymentInterestOnly }}</div>
</div>

<div class="details__field">
  <div class="details-label"
    [innerHTML]="referenceDataLabels.AffordabilityResultsMaxBorrowingIncomeMultiple | localizeLabel"></div>
  <div class="details-info"> {{ affordabilityResults.MaxBorrowingIncomeMultiple }}</div>
</div>

<div class="details__field">
  <div class="details-label"
    [innerHTML]="referenceDataLabels.AffordabilityResultsMaxBorrowingAffordability | localizeLabel"></div>
  <div class="details-info"> {{ affordabilityResults.MaxBorrowingAffordability }}</div>
</div>

<div class="details__field">
  <div class="details-label"
    [innerHTML]="referenceDataLabels.AffordabilityResultsPercentageOfNetIncomeAccountedForByMortgage | localizeLabel">
  </div>
  <div class="details-info"> {{ affordabilityResults.NetIncomePercentage }}</div>
</div>

<div class="details__field">
  <div class="details-label" [innerHTML]="referenceDataLabels.AffordabilityResultsIncomeSurplus | localizeLabel">
  </div>
  <div class="details-info"> {{ affordabilityResults.IncomeSurplus }}</div>
</div>

<div class="details__field">
  <div class="details-label"
    [innerHTML]="referenceDataLabels.AffordabilityResultsPercentageOfShortfallException | localizeLabel"></div>
  <div class="details-info"> {{ affordabilityResults.ShortfallExceptionPercentage }}</div>
</div>

<div class="details__field">
  <div class="details-label" [innerHTML]="referenceDataLabels.AffordabilityResultsMajorMinorException | localizeLabel">
  </div>
  <div class="details-info"> {{ affordabilityResults.MajorMinorException }}</div>
</div>

<br />

<ng-container *ngIf="affordabilityResults.NoOfApplicants > 0">
  <h3 class="bo-label-text" [innerHTML]="referenceDataLabels.AffordabilityResultsInputs | localizeLabel"></h3>

  <div class="dots-separator"></div>

  <div class="details__field">
    <div class="details-label" [innerHTML]="referenceDataLabels.AffordabiltyResultsNumberOfApplicants | localizeLabel">
    </div>
    <div class="details-info"> {{ affordabilityResults.NoOfApplicants }}</div>
  </div>

  <div class="details__field">
    <div class="details-label"></div>
    <div class="details-info multiple-values">
      <span class="bo-label-text multiple-value"
        [innerHTML]="referenceDataLabels.AffordabilityResultsApplicant1 | localizeLabel"></span>
      <span class="bo-label-text multiple-value"
        [innerHTML]="referenceDataLabels.AffordabilityResultsApplicant2 | localizeLabel"
        *ngIf="affordabilityResults.NoOfApplicants > 1"></span>
    </div>
  </div>

  <div class="details__field">
    <div class="details-label" [innerHTML]="referenceDataLabels.AffordabilityResultsGrossAnnualIncome | localizeLabel">
    </div>
    <div class="details-info multiple-values">
      <span class="bo-info-text multiple-value">{{ affordabilityResults.GrossAnnualIncomeApp1 }}</span>
      <span class="bo-info-text multiple-value" *ngIf="affordabilityResults.NoOfApplicants > 1">
        {{ affordabilityResults.GrossAnnualIncomeApp2 }}
      </span>
    </div>
  </div>

  <div class="details__field">
    <div class="details-label"
      [innerHTML]="referenceDataLabels.AffordabilityResultsOtherIncome | localizeLabel">
    </div>
    <span class="details-info  multiple-values">
      <span class="multiple-value">{{ affordabilityResults.OtherIncomeApp1 }}</span>
      <span class="multiple-value" *ngIf="affordabilityResults.NoOfApplicants > 1">
        {{ affordabilityResults.OtherIncomeApp2 }}
      </span>
    </span>
  </div>

  <div class="details__field">
    <div class="details-label"
      [innerHTML]="referenceDataLabels.AffordabilityResultsMonthlyCommittedOutgoings | localizeLabel"></div>
    <span class="details-info">{{ affordabilityResults.MonthlyCommittedOutgoing }}</span>
  </div>

  <div class="details__field">
    <div class="details-label"
      [innerHTML]="referenceDataLabels.AffordabilityResultsMonthlyOtherOutgoings | localizeLabel"></div>
    <span class="details-info">{{ affordabilityResults.MonthlyOtherOutgoing }}</span>
  </div>

  <div class="details__field">
    <div class="details-label" [innerHTML]="referenceDataLabels.AffordabilityResultsNumberOfAdults | localizeLabel">
    </div>
    <span class="details-info">{{ affordabilityResults.NoOfAdults }}</span>
  </div>

  <div class="details__field">
    <div class="details-label"
      [innerHTML]="referenceDataLabels.AffordabilityResultsNumberOfChildrenUnder18 | localizeLabel"></div>
    <span class="details-info">{{ affordabilityResults.NoOfChildren }}</span>
  </div>

  <div class="details__field">
    <div class="details-label" [innerHTML]="referenceDataLabels.AffordabilityResultsMortgageTerm | localizeLabel">
    </div>
    <span class="details-info">{{ affordabilityResults.MortgageTermYrs }} {{ yearsString }}
      {{ affordabilityResults.MortgageTermMths }}
      {{ monthsString }} </span>
  </div>

  <div class="details__field">
    <div class="details-label"
      [innerHTML]="referenceDataLabels.AffordabilityResultsRepaymentLoanAmount | localizeLabel"></div>
    <span class="details-info">{{ affordabilityResults.RepaymentLoanAmount }} </span>
  </div>

  <div class="details__field">
    <div class="details-label"
      [innerHTML]="referenceDataLabels.AffordabilityResultsInterestOnlyLoanAmount | localizeLabel"></div>
    <span class="details-info">{{ affordabilityResults.InterestOnlyLoanAmount }} </span>
  </div>

</ng-container>